export default class ContactViewModel {
    public id: number;
    public coreID: string;
    public sortOrder: number;
    public name: string;
    public phoneNumber: string;
    public email: string;
    public active: boolean;
    public modifiedDate: Date;
    public insertedDate: Date;
    public detectorsEmailActive: boolean;
    public shorePowerEmailActive: boolean;
    public smartplugEmailActive: boolean;
    public mainDoorEmailActive: boolean;
    public hatchEmailActive: boolean;
    public voltageLowEmailActive: boolean;
    public geofenceEmailActive: boolean;
    public lowBatterySensorEmailActive: boolean;
    public gatewayTamperedEmailActive: boolean;
    public gatewayPowerlossEmailActive: boolean;
    public gsmConnectionLostEmailActive: boolean;
    public detectorsSMSActive: boolean;
    public shorePowerSMSActive: boolean;
    public smartPlugSMSActive: boolean;
    public mainDoorSMSActive: boolean;
    public hatchSMSActive: boolean;
    public voltageLowSMSActive: boolean;
    public geofenceSMSActive: boolean;
    public lowBatterySensorSMSActive: boolean;
    public gatewayTamperedSMSActive: boolean;
    public gatewayPowerlossSMSActive: boolean;
    public gsmConnectionLostSMSActive: boolean;
}
